import React, { useState, useRef, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Modal from "react-bootstrap/Modal";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import axios from "axios";
import { apibaseurl, jwttoken } from "../../../environment";
import Loader from "../../../core/common/selfLoder";

interface TrainingEvent {
  training_name: string;
  training_type: string;
  training_date: string;
  training_time_from: string;
  training_time_to: string;
  description: string;
  status: string;
}

interface EventDetails {
  title: string;
  training_type: string;
  description: string;
  time_from: string;
  time_to: string;
  status: string;
  date: string;
}

const TrainingCalender = () => {
  const [loading, setLoading] = useState(true);
  const routes = all_routes;
  const [events, setEvents] = useState<any[]>([]);
  const [showEventDetailsModal, setShowEventDetailsModal] = useState(false);
  const [eventDetails, setEventDetails] = useState<EventDetails | null>(null);

  const calendarRef = useRef(null);

  const handleEventDetailsClose = () => setShowEventDetailsModal(false);

  const getApiData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apibaseurl}/api/traning-schedule`, {
        headers: {
          Authorization: `Bearer ${jwttoken}`,
        },
      });
      const transformedEvents = response.data.data.map(
        (training: TrainingEvent) => ({
          title: training.training_name,
          start: training.training_date,
          extendedProps: {
            training_type: training.training_type,
            description: training.description,
            time_from: training.training_time_from,
            time_to: training.training_time_to,
            status: training.status,
          },
        })
      );

      setEvents(transformedEvents);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // stop loader
    }
  };

  useEffect(() => {
    getApiData();
  }, []);

  const handleEventClick = (info: any) => {
    setEventDetails({
      title: info.event.title,
      training_type: info.event.extendedProps.training_type,
      description: info.event.extendedProps.description,
      time_from: info.event.extendedProps.time_from,
      time_to: info.event.extendedProps.time_to,
      status: info.event.extendedProps.status,
      date: info.event.startStr,
    });
    setShowEventDetailsModal(true);
  };

  return (
    <>
      <Loader loading={loading} />;{/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Training Calendar</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Application</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Training Calendar
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <Link
                  to="/nominations"
                  className="btn btn-primary d-flex align-items-center"
                >
                  {" "}
                  All Nominations
                </Link>
              </div>
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="row">
            <div
              className="card col-md-12 mb-3"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src="https://team1consulting.com/weconnect/assets/img/team1enrich.jpg"
                alt=""
              />
            </div>
            <div className="col-md-12 col-xxl-12 col-xl-12  theiaStickySidebar">
              <div className="stickybar">
                <div className="card border-0">
                  <div className="card-body">
                    <FullCalendar
                      plugins={[
                        dayGridPlugin,
                        timeGridPlugin,
                        interactionPlugin,
                      ]}
                      initialView="dayGridMonth"
                      events={events}
                      headerToolbar={{
                        start: "today,prev,next",
                        center: "title",
                        end: "dayGridMonth,dayGridWeek,dayGridDay",
                      }}
                      eventClick={handleEventClick}
                      ref={calendarRef}
                      height={600}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Event */}
      <Modal show={showEventDetailsModal} onHide={handleEventDetailsClose}>
        {eventDetails && (
          <>
            <div className="modal-header bg-dark modal-bg">
              <div className="modal-title text-white">
                <span id="eventTitle">{eventDetails.title}</span>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                onClick={handleEventDetailsClose}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <p className="d-flex align-items-center fw-medium text-black mb-3">
                <i className="ti ti-calendar-check text-default me-2" />
                {eventDetails.date}
              </p>
              <p className="d-flex align-items-center fw-medium text-black mb-3">
                <i className="ti ti-clock-hour-4 text-default me-2" />
                {eventDetails.time_from} to {eventDetails.time_to}
              </p>
              <p className="d-flex align-items-center fw-medium text-black mb-3">
                <i className="ti ti-user-check text-default me-2" />
                Type: {eventDetails.training_type}
              </p>
              <p className="d-flex align-items-center fw-medium text-black mb-0">
                <i className="ti ti-align-left text-default me-2" />
                {eventDetails.description}
              </p>
            </div>
          </>
        )}
      </Modal>
      {/* /Event */}
    </>
  );
};

export default TrainingCalender;
